import React from 'react';
import ArticleHeader from '../ArticleHeader';
import { Route, useParams, Switch } from 'react-router-dom';
import Revision from '../Revision';
import ArticleEditorProps from '../../interfaces/ArticleEditorProps'

interface ArticleProps {
  editor: (props: ArticleEditorProps) => JSX.Element,
  collection: string,
}

const Article = (props: ArticleProps) => {
  const { slug } = useParams<{ slug: string }>();

  // Use 'render' for didn't mount component like 'children'
  return (
    <Switch>
      <Route path={`/articles/create/${props.collection}`}>
        <>
          {props.editor({ type: "create" })}
        </>
      </Route>

      <Route path={`/articles/edit/${props.collection}/:slug/edit`}>
        <>
          <ArticleHeader type={props.collection} slug={slug} />
          {props.editor({ type: "edit" })}
        </>
      </Route>

      <Route path={`/articles/edit/${props.collection}/:slug/revision`} render={
        () => <>
          <ArticleHeader type={props.collection} slug={slug} />
          <Revision collection={props.collection} />
        </>
      } />

      <Route render={
        () => <h3 style={{ textAlign: 'center' }}>404 Not found</h3>
      } />

    </Switch>
  );
};

export default Article;